module.exports = __webpack_public_path__ + "img/user.08d30b8c.png";